module.exports = __webpack_public_path__ + "img/zhangwen.85cb77c7.jpg";